import { ICollectionsState } from './collections.interface';
import { vizByCollectionIdInitialState } from './vizByCollectionId/vizByCollectionId-initialState';

export const collectionsInitialState: ICollectionsState = {
  vizByCollection: vizByCollectionIdInitialState,
};
